module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/no-266dbd6fc3e66414aa3c05bb90510bf7.svg";